import React, { Component } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import Request from '../../request';
import { connect } from 'react-redux'
import FrontOfficeDashboard from './FrontDeskDashboard';
import TellecallerDashboard from '../../components/Dashboard/tellecaller'
import LeadManagerDashboard from './leadManager'
import OfficeManagerDashboard from './officeManager'
import OperationManagerDashboard from './operationManagerDashboard'
// import CounsellorDashboard from './counsellor'
import CounsellorDashboard from './counsellorDashboard';
// import RegistrationDashboard from './registration'
import RegistrationDashboard from './registrationDashboard';
// import AdmissionDashboard from './admission'
import AdmissionDashboard from './admissionDashboard';
// import VisaDashboard from './visaDashboard'
import VisaSupportDashboard from './visaSupportDashboard';
import VisaFillingDashboard from './visaFillingDashboard'
// import CliamCommissionDashboard from './claimCommission'
import CliamCommissionDashboard from './claimCommissionDashboard'
import FincanceCommissionDashboard from './financeCommission'
import RelationShipManager from './relationshipManager'
import BusinessDevelopmentDashboard from './businessDevelopment'
import MarketingDashboard from './marketing'
import DataOperationManager from './dataOperations'
import BlankDashboard from './blankDashboard'
import HRDashboard from './HRDashboard';
import common from '../common.less'
import Autosuggest from 'react-autosuggest';

import {
    FaUsers,
    FaUserTag,
    FaTasks,
    FaRegCalendarAlt,
    FaCalendarPlus,
    FaUserPlus,
    FaUserEdit
} from "react-icons/fa";

import { notification, Row, Col, Button } from 'antd'
import { RightsWrapper } from '../../components/_utils/utils'
import moment from 'moment'
import { TableComp } from 'sz-react-utils';
import DroppedLeads from '../../components/Dashboard/droppedLeads';
import TaskAppointments from './taskAppointments';
import RelationshipManagerDashboard from './relationshipManagerDashboard';
import ClaimAccountDashboard from './claimAccountDashboard';
import StudentPanelQRCode from '../../components/Dashboard/studentPanelQRCode';
import CompanySetupModal from '../../components/modals/companySetupModal';

// import DealerDashboard from './dealerDashboard'


const userDashboardNames = {
    "isFrontDesk": "Reception",
    "isOperation": "Operation Manager",
    "isCounsellor": "Counsellor",
    "isRegistration": "Registration",
    "isAdmission": "Admission",
    "isVisa": "Visa",
    "isClaim": "Claim",
    "isFinanceAdmin": "Finance Admin",
    "isRelationshipManager": "Relationship Manager"
}

const companyDetails = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')) : null
let intVar = null;

class Dashboard extends Component {

    constructor(props) {
        super(props)
        this.table = React.createRef()
        this.state = {
            timer: null,
            value: '',
            visaStatusCount: { visaFillings: [] },
            drawer: false,
            showAppointmentDrawar: false,
            showVisitedStudentForm: false,
            drawerParam: {},
            leads: {
                total: 0,
                arr: []
            },
            appointments: {},
            tasks: {
                total: 0
            },
            visiteds: {
                total: 0,
                arr: []
            },
            suggestions: [],
            studentDetail: {}
        }
    }

    loadAllApis = async () => {
        let response = await Request.getFrontOfficeData({ deleted: false });
        if (response) {
            this.setState({ ...response })
        }
    }

    componentDidMount() {
        if (localStorage.getItem('userLogout') == 'not') {
            localStorage.removeItem('userLogout');
            notification.warning({ message: "Your account was not logout, Please logout your account on daily BASIS.", duration: 40 })
        }
        intVar = setInterval(() => {
            this.setState({ timer: new Date() })

        }, 12000)
        this.checkCompanySetup();


        // this.loadAllApis();
    }

    componentWillReceiveProps(props) {
        const { timer } = this.props;
        if (props.timer !== timer) {
            this.loadAllApis();
        }
    }

    checkCompanySetup = async () => {
        if (!companyDetails || !companyDetails.completeSetup) {
            let response = await Request.getCompanySetting();
            if (response && !response.completeSetup) {
                this.setState({ setupCompanyModal: true });
            } else {
                this.setState({ setupCompanyModal: false }, () => {
                    localStorage.setItem('company-details', JSON.stringify(response));
                });

            }
        }

    }

    onSuggestionsFetchRequested = async () => {
        const { dispatch, form } = this.props
        let response = await Request.handleSearchStudent({
            searchField: this.state.searchField,
            results: 300
        });
        let suggestions = [];
        if (response.data) {
            response.data.map((student) => {
                suggestions.push({
                    id: student._id,
                    text: student.id + ' - ' + student.studentName + ' - ' + moment(student.dateOfBirth).format('ll')
                })
            })
        }
        this.setState({
            suggestions
        });
    }
    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };
    onSuggestionSelected = async (event, { suggestion }) => {
        let studentId = suggestion.id;
        let response = await Request.getStudentDetails(studentId);
        if (response) {
            this.setState({ studentDetail: response.doc });
            this.loadAllApis();
        }
    }
    onChange = (e) => {
        this.setState({
            value: e.target.value,
            searchField: e.target.value
        });
    };

    getSuggestionValue = (suggestion) => {
        return suggestion.text;
    }

    renderSuggestion = (suggestion) => {
        return <span>{suggestion.text}</span>;
    }

    componentWillUnmount() {
        clearInterval(intVar);
    }

    render() {
        const { currentUser } = this.props;
        const dashboardTitle = currentUser
            ? Object.keys(userDashboardNames)
                .filter(key => currentUser[key])
                .map(key => userDashboardNames[key])
                .join(" + ")
            : "";

        const branchName = currentUser && currentUser.branch_details && currentUser.branch_details.branchName ? ` - ${currentUser.branch_details.branchName}` : "";
        let columns = [
            {
                title: 'Vision ID',
                key: 'id'
            }
        ]

        const dashboardComponents = {
            isFrontDesk: FrontOfficeDashboard,
            isCounsellor: CounsellorDashboard,
            idRegistration: RegistrationDashboard,
            isAdmission: AdmissionDashboard,
            isVisa: VisaSupportDashboard,
            isFinanceAdmin: CliamCommissionDashboard,
            isRelationshipManager: RelationshipManagerDashboard,
            isClaim: ClaimAccountDashboard
        }

        const { drawer, suggestions, value, drawerParam, leads, tasks, visiteds, appointments, showVisitedStudentForm, studentDetail, showAppointmentDrawar } = this.state;
        // value = (value != undefined && value != 0?value:'');
        const inputProps = {
            placeholder: 'Search Student by Name, DOB, Mobile, Email ID',
            value,
            onChange: this.onChange
        };
        return (
            <PageHeaderWrapper
                title={currentUser && 'Dashboard ' + dashboardTitle + branchName}
            >
                {
                    this.state.setupCompanyModal ?
                        <CompanySetupModal onClose={() => this.setState({ setupCompanyModal: false }, () => this.checkCompanySetup())} />
                        : null
                }
                {/* <CliamCommissionDashboard /> */}
                <Row>
                    {
                        !currentUser.isFrontDesk ? <TaskAppointments /> : null
                    }

                    {currentUser &&
                        Object.keys(dashboardComponents).map((role) => {
                            const DashboardComponent = dashboardComponents[role];

                            return currentUser[role] ? (
                                <DashboardComponent key={role} />
                            ) : null;
                        })
                    }
                    {/* <StudentPanelQRCode /> */}
                    {/* Front Office Desk Dashboard
                <Row>
                    <Col span={6} style={{padding: '10px'}}>
                        <div className="info-box">
                            <span className="info-box-icon bg-color-1 elevation-1"><FaUsers /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Today's Leads</span>
                                <span className="info-box-number">
                                    <a onClick={() => {
                                        this.setState({
                                            drawer: true,
                                            showAppointmentDrawar: false,
                                            showVisitedStudentForm: false,
                                            drawerParam: {
                                                title: `Today's Leads`,
                                                arr: leads.arr,
                                                count: leads.total
                                            }
                                        })
                                    }}>{leads.total}</a>
                                    <RightsWrapper myRight={"Student.add"}>
                                        <span style={{float: 'right'}}>
                                            <Button className='bg-color-1'><a  href="/inquiry/add" target='_blank'><FaUserPlus /></a></Button>
                                        </span>
                                    </RightsWrapper>
                                </span>
                            </div>
                        </div>
                    </Col>
                    <Col span={6} style={{padding: '10px'}}>
                        <div className="info-box">
                            <span className="info-box-icon bg-color-2 elevation-1"><FaUserTag /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Today's Visited</span>
                                <span className="info-box-number">                                    
                                    <a onClick={() => {
                                        this.setState({
                                            drawer: true,
                                            showAppointmentDrawar: false,
                                            drawerParam: {
                                                title: `Today's Visited`,
                                                arr: visiteds.arr,
                                                count: visiteds.total
                                            }
                                        })
                                    }}>{visiteds.total}</a>
                                    <span style={{float: 'right'}}>
                                        <Button onClick={() => {
                                            this.setState({
                                                showVisitedStudentForm: true,
                                                showAppointmentDrawar: false,
                                            })
                                        }} className='bg-color-2'><FaUserEdit /></Button>                                      
                                    </span>
                                </span>
                            </div>
                        </div>
                    </Col>
                    <Col span={6} style={{padding: '10px'}}>
                        <div className="info-box">
                            <span className="info-box-icon bg-color-3 elevation-1"><FaTasks /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Today's Tasks</span>
                                <span className="info-box-number">
                                    {tasks.total}
                                </span>
                            </div>
                        </div>
                    </Col>
                    <Col span={6} style={{padding: '10px'}}>
                        <div className="info-box">
                            <span className="info-box-icon bg-color-4 elevation-1"><FaRegCalendarAlt /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Today's Appointments</span>
                                <span className="info-box-number">
                                    <a onClick={() => {
                                        this.setState({
                                            showVisitedStudentForm: false,
                                            showAppointmentDrawar: true
                                        })
                                    }}>{appointments.total}</a>
                                    <span style={{float: 'right'}}>
                                        <Button className='bg-color-4'>
                                            <a href='/appointment' target='_blank'><FaCalendarPlus /></a>
                                        </Button>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </Col>
                    {
                        showAppointmentDrawar && appointments.total > 0 ? 
                            <Col span={24}>
                                <h2>{`Appointments : ${appointments.total}`}</h2>
                                <table cellPadding={10} className='student-custom-table'>
                                    <thead>
                                        <tr>
                                            <th>Appointment Id</th>
                                            <th>Subject</th>
                                            <th>Type</th>
                                            <th>Name</th>
                                            <th>Date/time</th>
                                            <th>Attendees</th>
                                            <th>Created By</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            appointments.data.map((appointment, index) => {
                                                return(
                                                    <tr key={index}>
                                                        <td>{appointment.appId}</td>
                                                        <td>{appointment.subject}</td>
                                                        <td>{appointment.fromType}</td>
                                                        <td>{appointment.name}</td>
                                                        <td>
                                                            <div>{appointment && moment(appointment.startDate).format('DD-MMM-YYYY')}</div>
                                                            <div>{appointment && appointment.startTime}</div>
                                                        </td>
                                                        <td>
                                                            <div>{appointment && appointment.attendees && appointment.attendees.length && appointment.attendees.map((item) => {
                                                                return <span>{item} {`, ${'\n'}`}</span>
                                                            })}</div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <div className={common.user}>{appointment ? appointment.name : ''}</div>
                                                                <small>{appointment ? moment(appointment.time).format('lll') : ''}</small>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </Col>
                        :null
                    }    
                    {
                        showVisitedStudentForm ?
                            <Col span={24}>
                                <h2>{`Search Student by Name, DOB(11/11/2003), Mobile, Email ID`}</h2>
                                <Autosuggest
                                    suggestions={suggestions}
                                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                    onSuggestionSelected={this.onSuggestionSelected}
                                    getSuggestionValue={this.getSuggestionValue}
                                    renderSuggestion={this.renderSuggestion}
                                    inputProps={inputProps}
                                    className="auto-complete-input"
                                />
                                {
                                    studentDetail && studentDetail.id ?
                                        <div className=''>
                                            <table cellPadding={10} className='student-custom-table'>
                                                <tbody>
                                                    <tr>
                                                        <th>Vision ID</th>
                                                        <td>{studentDetail.id}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Student Name</th>
                                                        <td>{studentDetail.studentName}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>DOB</th>
                                                        <td>{moment(studentDetail.dateOfBirth).format('ll')}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Desk</th>
                                                        <td>{studentDetail.atLevel}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Mode</th>
                                                        <td>{studentDetail.mode}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Counsellor</th>
                                                        <td>{studentDetail.counsellorId && studentDetail.counsellorId.name}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Branch</th>
                                                        <td>{studentDetail.studentBranchId && studentDetail.studentBranchId.branchName}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    :null
                                }
                            </Col>
                        :null
                    }                
                </Row>  */}
                    {/* <FrontOfficeDashboard /> */}
                    {/* <OperationManagerDashboard /> */}
                    {/* <CounsellorDashboard /> */}
                    {/* <RegistrationDashboard /> */}
                    {/* <AdmissionDashboard /> */}
                    {/* <VisaSupportDashboard /> */}
                    {/* <VisaFillingDashboard /> */}
                    <RelationShipManager />
                    {/* <CliamCommissionDashboard /> */}
                    {/* <FincanceCommissionDashboard /> */}
                    {/* <DroppedLeads />
                    <TellecallerDashboard />
                    <LeadManagerDashboard />
                    <OfficeManagerDashboard />
                    <CounsellorDashboard />
                    <RegistrationDashboard />
                    <AdmissionDashboard />
                    <VisaDashboard />
                    <VisaFillingDashboard />
                    <CliamCommissionDashboard />
                    <FincanceCommissionDashboard />
                    <RelationShipManager />
                    <BusinessDevelopmentDashboard />
                    <MarketingDashboard />
                    <DataOperationManager />
                    <HRDashboard />
                    <BlankDashboard /> */}
                </Row>
                <div>
                    {/* {currentUser && currentUser.dashboard == 'FrontOffice' && <FrontOfficeDashboard/>}
                    {currentUser && currentUser.dashboard == 'Tellecaller' && <TellecallerDashboard/>}
                    {currentUser && currentUser.dashboard == 'LeadManager' && <LeadManagerDashboard />}
                    {currentUser && currentUser.dashboard == 'OfficeManager' && <OfficeManagerDashboard/>}
                    {currentUser && currentUser.dashboard == 'OperationManager' && <OperationManagerDashboard/>}
                    {currentUser && currentUser.dashboard == 'Counsellor' && <CounsellorDashboard/>}
                    {currentUser && currentUser.dashboard == 'Registration' && <RegistrationDashboard/>}
                    {currentUser && currentUser.dashboard == 'Admission' && <AdmissionDashboard/>}
                    {currentUser && currentUser.dashboard == 'VisaSupport' && <VisaDashboard/>}
                    {currentUser && currentUser.dashboard == 'VisaFilling' && <VisaFillingDashboard/>}
                    {currentUser && currentUser.dashboard == 'ClaimCommission' && <CliamCommissionDashboard/>}
                    {currentUser && currentUser.dashboard == 'FinanceCommission' && <FincanceCommissionDashboard/>}
                    {currentUser && currentUser.dashboard == 'RelationshipManager' && <RelationShipManager/>}
                    {currentUser && currentUser.dashboard == 'BusinessDevelopment' && <BusinessDevelopmentDashboard/>}
                    {currentUser && currentUser.dashboard == 'Marketing' && <MarketingDashboard/>}
                    {currentUser && currentUser.dashboard == 'DataOperations' && <DataOperationManager/>}
                    {currentUser && currentUser.dashboard == 'HR' && <HRDashboard/>}
                    {currentUser && currentUser.dashboard == 'Vision' && <BlankDashboard/>} */}
                </div>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global }) => ({
    categories: global.categories,
    loading: global.buttonLoading,
    currentUser: global.currentUser

})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)
    (Dashboard)
